import React from "react";
import Layout from "../components/layout";
import Slices from "../components/Slices";
import SEO from "../components/seo";
import { graphql } from "gatsby";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import { linkResolver } from "../../linkResolver";
import { ModalProvider } from "../Contexts/openModal";

const PageV3 = ({ data, location }) => {
  const { prismicPageV3: { data: _data = {} } = {} } = data;
  const isFirstSliceDark = !!Object.keys(
    _data.body.find((x, i) => i === 0 && x.primary?.theme === "dark") || {}
  )?.length;

  return (
    <Layout
      location={location}
      theme={isFirstSliceDark ? "transparent" : "newDefault"}
    >
      <ModalProvider>
        <Slices slices={data} location={location} />
      </ModalProvider>
    </Layout>
  );
};

export const query = graphql`
  {
    prismicPageV3(uid: { eq: "404-error-page" }) {
      data {
        meta_description {
          text
        }
        meta_heading {
          text
        }
        banner_title {
          text
          html
        }
        body {
          ... on PrismicPageV3DataBodyHeroKusama {
            id
            slice_type
            slice_label
            primary {
              show_email_cta
              cta_link {
                url
              }
              banner_link {
                url
              }
              banner_text {
                text
                html
              }
              descriptor_text {
                text
              }
              hero_title {
                text
                html
              }
              image {
                alt
                url
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              hs_class {
                text
              }
              hs_id {
                text
              }
              cta_title {
                text
              }
              caption_title {
                text
              }
              show_caption_title
              theme
              heading_section_position
              top_spacing
              bottom_spacing
              logos_caption_title {
                text
              }
              static_image_1 {
                alt
                url
                gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
              }
              static_image_2 {
                alt
                url
                gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
              }
              static_image_3 {
                alt
                url
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              video_link {
                url
              }
              cta_banner_caption_title {
                text
              }
              cta_banner_title {
                text
              }
              cta_banner_thumbnail {
                url
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              secondary_cta_link {
                url
              }
              secondary_cta_title {
                text
              }
              background_image {
                url
                alt
              }
            }
            items {
              logo {
                url
                alt
                gatsbyImageData(placeholder: NONE, layout: CONSTRAINED)
              }
              text {
                text
              }
            }
          }
        }
      }
      uid
      _previewable
    }
  }
`;

export const Head = ({ data }) => {
  return (
    <SEO
      title={`${data?.prismicPageV3?.data?.meta_heading?.text}`}
      description={data?.prismicPageV3?.data?.meta_description?.text}
    />
  );
};

export default withPrismicPreview(PageV3, [
  {
    repositoryName: "encord",
    linkResolver: linkResolver,
  },
]);
